import { queries } from '../../graphql/queries';
import BaseEntityService from './BaseEntityService';

class WatchlistService extends BaseEntityService {
  listQuery = queries.watchlists;
}

export const watchlistService = new WatchlistService();
